module.exports = __webpack_public_path__ + "static/media/github_logo.6eeb2e81.png";